import { useState } from 'react';
import { Menu } from 'antd';
import { EditOutlined, FileAddOutlined } from '@ant-design/icons';
import ExportProductPropertiesModal from '../../modal/bulk-edit-product/ExportProductPropertiesModal';
import RibbonButton from 'common/components/button/RibbonButton';
import * as qaSpecServices from 'services/qaSpec';
import * as api from 'config/axios';
import { notification } from 'antd';
import { useIntl } from 'react-intl';
import Messages from 'i18n/messages/product';

const AddEditQaSpecTemplate = (props) => {
  const intl = useIntl();

  const {
    disabled,
    selectedProducts,
    selectedFolders,
    disabledExport,
    isProductDetail = false,
  } = props;

  const [visibleExportModal, setVisibleExportModal] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);

  const onClickExportButton = (mode) => {
    handleExport(mode);
  };

  const handleExport = (mode) => {
    setSubmitLoading(true);

    const params = {
      productIds: selectedProducts,
      action: mode,
    };

    qaSpecServices
      .downloadQaSpecTemplate(params)
      .then((response) => {
        const { isSuccess, data } = response;
        if (isSuccess && data?.url?.length) {
          data.url.forEach((fileUrl) => {
            api.sendDownload({ url: fileUrl });
          });
        } else {
          handleDownloadManualError(response);
        }
      })
      .catch((response) => {
        setSubmitLoading(false);
        handleDownloadManualError(response);
      }).finally(() => {
        setSubmitLoading(false);
      });
  };

  const handleDownloadManualError = (response) => {
    notification.error({
      message:
        response?.message ||
        response?.data?.message ||
        intl.formatMessage(Messages.exportQaSpecDownloadManualError),
    });
  };

  return (
    <>
      <Menu.Item
        key='export-selected-product-properties'
        style={{
          backgroundColor: 'inherit',
          width: '150px',
        }}
      >
        <RibbonButton
          size='small'
          className='button-item-dropdown'
          icon={<FileAddOutlined />}
          label={'Add'}
          onClick={() => onClickExportButton('Add')}
        />
      </Menu.Item>
      <Menu.Item
        key='import-product-properties'
        style={{
          backgroundColor: 'inherit',
        }}
      >
        <RibbonButton
          size='small'
          className='button-item-dropdown'
          icon={<EditOutlined />}
          label={'Edit'}
          onClick={() => onClickExportButton('Edit')}
        />
      </Menu.Item>

      {visibleExportModal && (
        <ExportProductPropertiesModal
          visible={visibleExportModal}
          setVisible={setVisibleExportModal}
          selectedProducts={selectedProducts}
          selectedFolders={selectedFolders}
        />
      )}
    </>
  );
};

export default AddEditQaSpecTemplate;
